import classNames from 'classnames';
import SafeHtml from '@/components/safe-html';
import ExpandableText from './expandable-text';
export interface Props {
  text?: string;
  className?: string;
  isBlack?: boolean;
  onlyShowH1?: boolean;
}
export function Text({
  text,
  className,
  isBlack,
  onlyShowH1
}: Props) {
  if (!text) return null;
  const contentClassName = classNames('homepage-container text-body-14 text-text-black lg:text-body-16 [&_a]:font-bold [&_a]:!text-[#DB2777] [&_a]:no-underline hover:[&_a]:underline [&_h2:first-child]:mb-4 lg:[&_h2:first-child]:mb-6 [&_h2]:!font-bold [&_ol]:list-decimal [&_ol]:pr-10 [&_ul]:list-disc [&_ul]:pr-10', isBlack ? 'text-text-white' : 'text-text-black', className);
  if (isBlack) return <ExpandableText content={text} onlyShowH1={onlyShowH1} contentClassName={contentClassName} />;
  return <SafeHtml content={text} className={contentClassName} data-sentry-element="SafeHtml" data-sentry-component="Text" data-sentry-source-file="text.tsx" />;
}